import * as React from "react";

export default class HowItWorksModal extends React.PureComponent {
  render() {
    return (
      <div
        className="modal fade"
        id="howItWorksModal"
        role="dialog"
        aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <p className="subheading">
                Det kan aldrig gå fel, det här händer när du tryckt på "skicka
                beställning"
              </p>
              <ul>
                <li>Vi mailar dig en bekräftelse.</li>
                <li>
                  Vi hämtar in uppgifter om din anläggning och din förbrukning.
                </li>
                <li>
                  Vi kollar när ditt avtal löper ut och när vi kan byta åt dig.
                </li>
                <li>Vi genomför bytet och meddelar dig när det är klart.</li>
                <li>
                  Du får ett rörligt avtal där du betalar månadsvis för din
                  förbrukning. Vi hämtar förbrukningen automatiskt.
                </li>
                <li>
                  Du får din första elfaktura en månad efter att bytet är klart.
                </li>
                <li>
                  Du kan betala t.ex. via Swish, Autogiro eller E-faktura.
                </li>
                <li>
                  Du slipper tänka på elavtal mer och kan göra roligare saker.
                </li>
              </ul>
              <p>Inga bindingstider eller uppsägningstider</p>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal">
                Tack, då vet jag
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
